module.exports = __webpack_public_path__ + "./img/TankYou-v2.5917698684ecb7f687cc16f9d9afc35c.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/TankYou-v2.png
// module id = ./public/img/TankYou-v2.png
// module chunks = 0